export default __webpack_public_path__ + "static/media/samsung_stimuli_es_phone.44e46e9e.mp4";